module.exports = __webpack_public_path__ + "static/media/angular bracket thing.0c6d7ee9.png";